import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AiInput } from '@/shared/ui';

type BlockPointsFieldProps = {
  maxPoints: number | null;
  possiblePoints: number[] | null;
  isProcessing: boolean;
};

/**
 * Баллы листового блока: максимальный и перечень возможных.
 * Значения определяет сервер по правилам блока, поэтому поле недоступно для ввода.
 */
export const BlockPointsField: FC<BlockPointsFieldProps> = ({ maxPoints, possiblePoints, isProcessing }) => {
  const { t } = useTranslation('expertReport');

  const getValue = () => {
    if (maxPoints === null) return '';
    if (!possiblePoints?.length) return t('pointsMaxOnly', { max: maxPoints });
    return t('pointsValue', { max: maxPoints, possible: possiblePoints.join(', ') });
  };

  return (
    <AiInput
      label={t('points')}
      value={getValue()}
      placeholder={t('pointsNotResolved')}
      disabled
      isProcessing={isProcessing}
    />
  );
};
